export default "__VITE_ASSET__Bj1eU_yz__"